import { render, staticRenderFns } from "./SyntheseProduit.vue?vue&type=template&id=758abfa8&scoped=true"
import script from "./SyntheseProduit.vue?vue&type=script&lang=js"
export * from "./SyntheseProduit.vue?vue&type=script&lang=js"
import style0 from "./SyntheseProduit.vue?vue&type=style&index=0&id=758abfa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758abfa8",
  null
  
)

export default component.exports